import React, { useGlobal, setGlobal, useEffect, useDispatch, useState } from "reactn";
import { Outlet, Link, useNavigate } from "react-router-dom";
import "../assets/styles/Header.css";

import CartModal from "./CartModal";
const cart = require("../assets/imgs/shopping-cart.png");
const logo = require("../assets/imgs/header-logo.png");

const Header = () => {
  const [token, setToken] = useGlobal("token");
  const [userInfo, setUserInfo] = useGlobal("userInfo");
  const [loading, setLoading] = useGlobal("loading");
  const [openCartModal, setOpenCartModal] = useState(false);
  const navigate = useNavigate();

  const logout = useDispatch((global, _dispatch) => ({
    ...global,
    token: "",
    userInfo: {
      id: undefined,
      business: "",
      name: "",
      street_address: "",
      city: "",
      province: "",
      postal_code: "",
      email: "",
      phone: "",
      username: "",
      password: "",
      is_admin: false,
      created_at: undefined
    }
  }));

  // useEffect(() => {
  //   if (localStorage.getItem("token")) {
  //     setToken(localStorage.getItem("token"));
  //   }
  // }, []);

  return (
    <>
      <div className="header-wrapper">
        <img className="logo" src={logo} alt="Milestone Autosupplies Inc Logo"/>
          <span style={{ fontSize: "50px", wordSpacing: "10px" }}> <b>Milestone Autosupplies Inc.</b></span>
          <nav>
                <ul>
                  { userInfo.is_admin && 
                    <li>
                      <Link to="/">
                        Home
                      </Link>
                    </li>
                  }
                  { userInfo.is_admin && 
                    <li>
                      <Link to="/admin">
                        Admin
                      </Link>
                    </li>
                  }
                  </ul>
                  {/*<li>
                    <Link to="/account">Account</Link>
                  </li> 
                </ul>
                <button className="cart-button"
                  onClick={() => {
                    setOpenCartModal(!openCartModal);
                    setLoading(!openCartModal);
                  }}
                >
                  <img className="cart-img" src={cart}/>
                </button>*/}
                {userInfo.is_admin && 
                  <button className="logout-btn"
                    onClick={() => {
                      localStorage.clear();
                      logout();
                      navigate("../");
                    }}
                  >
                    Log-out
                  </button>
                }
              </nav>
        {/*
          openCartModal && 
          <CartModal
            onBlur={() => {setOpenCartModal(false); setLoading(false); } }
          />
        */}
      </div>
      <Outlet/>
    </>
  );
}

export default Header;